import styles from "./location.module.css";
import React from "react";
import { useState } from "react";
const Location = () => {
    return (
    <section className={styles.tedxlocation}>
        <div className={styles.location}><h1>Location</h1></div>
    <div className={styles.locationcontainer}>
        <div className={styles.mapbox}>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3580.1989595483715!2d91.68947447519828!3d26.190205377085185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a5ac3dddc3601%3A0xfff84915e863cea1!2sAdministrative%20Block%2C%20IIT%20Guwahati!5e0!3m2!1sen!2sin!4v1734669677398!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"></iframe>
        </div>
        <div className={styles.informationbox}>
            <h4 className={styles.venuesubtitle}>CONFERENCE VENUE</h4>
            <h2 className={styles.venuetitle}>Hosted in <span className={styles.redText}>IIT Guwahati</span></h2>
        <p className={styles.description}>
            Join us at the <strong>Bhupen Hazarika Auditorium</strong> for an unforgettable experience of "Ideas worth spreading"

        </p>
        <div className={styles.detailscard}>
            <p><strong>Location:    </strong>  Mini Auditorium IITG</p>
            <p><strong>Date:    </strong>  08th Feb 2026</p>
            <p><strong>Time:    </strong>  9:00 AM</p>
        </div>
        <a href="https://maps.app.goo.gl/2dkMRZNZyQbS2sW26" target="blank"  className={styles.tedxbutton}>View Location</a>
        </div>
    </div>
</section>
);
};
export default Location;

